import React, { useState } from "react";
import RetreatApi from "../api/retreatApi";
import { toast } from "react-toastify";
import AlertModal from "../components/AlertModel";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  confirmationFlag,
  getChecklistEntry,
  formatConfirmDate,
  formatConfirmRole,
  isFlagOn,
} from "../helpers/confirmationAudit";
import "../assets/css/ConfirmationAuditModal.css";

const Confirmations = ({
  retreatHeading,
  setSelectedRetreat,
  setRetreatHeading,
  handleConfirmStatus,
  setIncommingRetreats,
  userData,
}) => {
  let retreatApi = new RetreatApi();
  const [confirmDir, setConfirmDir] = useState(false);
  const [confirmProg, setConfirmProg] = useState(false);
  const [confirmRoastData, setConfirmRoastData] = useState(false);
  const [confirmPictures, setConfirmPictures] = useState(false);
  const [confirmation, setConfirmation] = useState([]);
  const [pendingUnconfirm, setPendingUnconfirm] = useState(false);

  const confirmAlert = async (retreatData, item) => {
    const isAlreadyConfirmed = confirmationFlag(retreatData, item);
    setPendingUnconfirm(isAlreadyConfirmed);

    const payload = [
      { retreatData: retreatData, item, userData: userData },
    ];

    if (item === "Directory") {
      setConfirmDir(true);
      setConfirmation(payload);
    } else if (item === "Program") {
      setConfirmProg(true);
      setConfirmation(payload);
    } else if (item === "pictures") {
      setConfirmPictures(true);
      setConfirmation(payload);
    } else {
      setConfirmRoastData(true);
      setConfirmation(payload);
    }
  };

  const closeConfirmAlert = () => {
    setConfirmDir(false);
    setConfirmProg(false);
    setConfirmRoastData(false);
    setConfirmation([]);
    setConfirmPictures(false);
    setPendingUnconfirm(false);
  };

  const handleConfirmation = () => {
    retreatApi
      .handleConfirmation(confirmation)
      .then(async (res) => {
        if (res.success) {
          toast.success(res.message);
          closeConfirmAlert();
          if (typeof handleConfirmStatus === "function") {
            handleConfirmStatus();
          }
          if (typeof setSelectedRetreat === "function") {
            setSelectedRetreat(res.data.id);
          }
          if (typeof setRetreatHeading === "function") {
            setRetreatHeading(res.data);
          }
          if (typeof setIncommingRetreats === "function") {
            setIncommingRetreats((prevRetreats) =>
              prevRetreats.map((item) =>
                item.id === res.data.id ? { ...item, ...res.data } : item,
              ),
            );
          }
        } else {
          toast.error(res.message);
          closeConfirmAlert();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const directoryDownloadHref = retreatHeading?.directoryFile
    ? retreatHeading.directoryFile
    : retreatHeading?.directoryStatus === "PUBLISH" && retreatHeading?.id
      ? `/directory/${retreatHeading.id}?download=1`
      : "";

  const programDownloadHref = retreatHeading?.programFile
    ? retreatHeading.programFile
    : retreatHeading?.programStatus === "PUBLISH" && retreatHeading?.id
      ? `/program/${retreatHeading.id}?download=1`
      : "";

  const toggles = [
    {
      name: "roasterData",
      id: "roasterData",
      label: confirmationFlag(retreatHeading, "roasterData")
        ? "Confirmed Roster Data"
        : "Confirm Roster Data",
    },
    {
      name: "Directory",
      id: "directory",
      label: confirmationFlag(retreatHeading, "Directory")
        ? "Confirmed Directory"
        : "Confirm Directory",
    },
    {
      name: "Program",
      id: "program",
      label: confirmationFlag(retreatHeading, "Program")
        ? "Confirmed Program"
        : "Confirm Program",
    },
    {
      name: "pictures",
      id: "pictures",
      label: confirmationFlag(retreatHeading, "pictures")
        ? "Confirmed the Pictures"
        : "Confirm the Pictures",
    },
  ];

  const renderToggleTooltip = (itemKey) => {
    const entry = getChecklistEntry(retreatHeading, itemKey);
    const confirmed = confirmationFlag(retreatHeading, itemKey);
    if (confirmed) {
      const isSystem =
        entry?.confirmedByRole === "SYSTEM" ||
        entry?.source === "system" ||
        entry?.confirmedByName === "Automatic (system)";
      const name = isSystem
        ? "Automatic (system)"
        : entry?.confirmedByName || "Unknown";
      const email = isSystem ? "" : entry?.confirmedByEmail || "";
      const role = formatConfirmRole(entry?.confirmedByRole);
      const date = formatConfirmDate(entry?.ConfirmedDate);
      return (
        <Tooltip className="confirm-audit-tooltip">
          <div className="confirm-audit-tip">
            <strong>{name}</strong>
            {email ? <span>{email}</span> : null}
            {role ? <span>{role}</span> : null}
            {date ? <span>{date}</span> : null}
          </div>
        </Tooltip>
      );
    }

    if (entry?.unconfirmedByName) {
      const isSystem =
        entry?.unconfirmedByRole === "SYSTEM" ||
        entry?.unconfirmedByName === "Automatic (system)";
      return (
        <Tooltip className="confirm-audit-tooltip">
          <div className="confirm-audit-tip">
            <strong>Not confirmed</strong>
            <span>
              Last unconfirmed by{" "}
              {isSystem ? "Automatic (system)" : entry.unconfirmedByName}
            </span>
            {!isSystem && entry.unconfirmedByEmail ? (
              <span>{entry.unconfirmedByEmail}</span>
            ) : null}
            {entry.UnconfirmedDate ? (
              <span>{formatConfirmDate(entry.UnconfirmedDate)}</span>
            ) : null}
          </div>
        </Tooltip>
      );
    }

    return (
      <Tooltip className="confirm-audit-tooltip">
        <div className="confirm-audit-tip">
          <strong>Not confirmed</strong>
        </div>
      </Tooltip>
    );
  };

  const confirmMessage = (itemLabel) =>
    pendingUnconfirm
      ? `Are you sure you want to unconfirm the ${itemLabel} for this Retreat?`
      : `Are you sure you want to confirm the ${itemLabel} for this Retreat?`;

  return (
    <div className="circles_Confirmations">
      <div className="circles2_Confirmations">
        {toggles.map((toggle) => (
          <div className="d-flex leftSideButtons" key={toggle.id}>
            <Form.Check
              disabled={
                retreatHeading?.freeze === "FREEZE" ||
                Boolean(retreatHeading?.retreatCloseStatus) ||
                isFlagOn(retreatHeading?.confirmedByAdmin)
              }
              className={`switchSize confirm-toggle ${
                confirmationFlag(retreatHeading, toggle.name)
                  ? "toggle-on"
                  : "toggle-off-confirm"
              }`}
              type="switch"
              name={toggle.name}
              value={confirmationFlag(retreatHeading, toggle.name) || false}
              checked={confirmationFlag(retreatHeading, toggle.name) || false}
              onChange={() => confirmAlert(retreatHeading, toggle.name)}
              id={toggle.id}
            />
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 200 }}
              overlay={renderToggleTooltip(toggle.name)}
            >
              <h6
                className={`default ${
                  confirmationFlag(retreatHeading, toggle.name)
                    ? "confirmLabel"
                    : "noConfirmLabel"
                }`}
              >
                <a>{toggle.label}</a>
              </h6>
            </OverlayTrigger>
            {toggle.name === "Directory" && directoryDownloadHref ? (
              <a
                href={directoryDownloadHref}
                target="_blank"
                rel="noopener noreferrer"
                className="ms-2"
              >
                <i
                  title="Download Directory"
                  className="mdi mdi-download"
                  style={{ color: "#4cd964", fontSize: "1.2rem" }}
                ></i>
              </a>
            ) : null}
            {toggle.name === "Program" && programDownloadHref ? (
              <a
                href={programDownloadHref}
                target="_blank"
                rel="noopener noreferrer"
                className="ms-2"
              >
                <i
                  title="Download Program"
                  className="mdi mdi-download"
                  style={{ color: "#4cd964", fontSize: "1.2rem" }}
                ></i>
              </a>
            ) : null}
          </div>
        ))}
      </div>

      {confirmDir ? (
        <AlertModal
          cancel={"Cancel"}
          okay={"Okay"}
          show={confirmDir}
          handleClose={closeConfirmAlert}
          message={confirmMessage("Directory")}
          actionFunction={handleConfirmation}
          heading={"ALERT!!"}
        />
      ) : null}

      {confirmProg ? (
        <AlertModal
          cancel={"Cancel"}
          okay={"Okay"}
          show={confirmProg}
          handleClose={closeConfirmAlert}
          message={confirmMessage("Program")}
          actionFunction={handleConfirmation}
          heading={"ALERT!!"}
        />
      ) : null}

      {confirmRoastData ? (
        <AlertModal
          cancel={"Cancel"}
          okay={"Okay"}
          show={confirmRoastData}
          handleClose={closeConfirmAlert}
          message={confirmMessage("Roster Data")}
          actionFunction={handleConfirmation}
          heading={"ALERT!!"}
        />
      ) : null}

      {confirmPictures ? (
        <AlertModal
          show={confirmPictures}
          handleClose={closeConfirmAlert}
          message={confirmMessage("Pictures")}
          actionFunction={handleConfirmation}
          cancel={"Cancel"}
          okay={"Okay"}
          heading={"ALERT!!"}
        />
      ) : null}
    </div>
  );
};

export default Confirmations;
